import { render } from "./CodeBlock.vue?vue&type=template&id=29f52905&ts=true"
import script from "./CodeBlock.vue?vue&type=script&lang=ts"
export * from "./CodeBlock.vue?vue&type=script&lang=ts"

import "./CodeBlock.vue?vue&type=style&index=0&id=29f52905&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__